// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  addresses: {
    name: 'addresses',
    componentName: 'Addresses',
    chunk: () =>
      import(
        /* webpackChunkName: "addresses" */
        './pages/Addresses'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/Addresses.tsx'),
          ).Addresses
        : currentRouteName === 'addresses'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({
                default: pageModule.Addresses,
              })),
            );
    },
    path: '/:context?/myaccount/addresses',
    channel: null,
  },
  addCreditCard: {
    name: 'addCreditCard',
    componentName: 'AddCreditCard',
    chunk: () =>
      import(
        /* webpackChunkName: "addCreditCard" */
        './pages/Add-Credit-Card'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/Add-Credit-Card.tsx'),
          ).AddCreditCard
        : currentRouteName === 'addCreditCard'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({
                default: pageModule.AddCreditCard,
              })),
            );
    },
    path: '/:context?/myaccount/payments/addcreditcard',
    channel: null,
  },
  instantCheckout: {
    name: 'instantCheckout',
    componentName: 'InstantCheckout',
    chunk: () =>
      import(
        /* webpackChunkName: "instantCheckout" */
        './pages/Instant-Checkout'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/Instant-Checkout.tsx'),
          ).InstantCheckout
        : currentRouteName === 'instantCheckout'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({
                default: pageModule.InstantCheckout,
              })),
            );
    },
    path: '/:context?/myaccount/payments/instant-checkout',
    channel: null,
  },
  enrollHDWalletFromNativeApp: {
    name: 'authorizehdwallet',
    componentName: 'HDWalletAuth',
    chunk: () =>
      import(
        /* webpackChunkName: "HDWalletAuth" */
        './pages/HDWalletAuth'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/HDWalletAuth.tsx'),
          ).HDWalletAuth
        : currentRouteName === 'authorizehdwallet'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({
                default: pageModule.HDWalletAuth,
              })),
            );
    },
    path: '/:context?/myaccount/payments/authorizehdwallet',
    channel: null,
  },
  remotePurchasesPerfTest: {
    name: 'remotePurchasesPerfTest',
    componentName: 'RemotePurchasesPage',
    chunk: () =>
      import(
        /* webpackChunkName: "remote-purchases-perf" */
        './pages/Remote-Purchases-Perf'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/Remote-Purchases-Perf.tsx'),
          ).RemotePurchasesPage
        : currentRouteName === 'remotePurchasesPerfTest'
          ? currentRouteComponent
          : generateAsyncRoute(() => {
              return this.chunk().then((pageModule) => {
                return {
                  default: pageModule.RemotePurchasesPage,
                };
              });
            });
    },
    path: '/:context?/myaccount/payments/remote-purchases-perf-test',
    channel: null,
  },
  bulkAddCreditCards: {
    name: 'bulkAddCreditCards',
    componentName: 'BulkAddCreditCards',
    chunk: () =>
      import(
        /* webpackChunkName: "bulkAddCreditCards" */
        './pages/Bulk-Add-Credit-Cards'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/Bulk-Add-Credit-Cards.tsx'),
          ).BulkAddCreditCards
        : currentRouteName === 'bulkAddCreditCards'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({
                default: pageModule.BulkAddCreditCards,
              })),
            );
    },
    path: '/:context?/myaccount/payments/bulkaddcreditcards',
    channel: null,
  },
  addGiftCard: {
    name: 'addGiftCard',
    componentName: 'AddGiftCard',
    chunk: () =>
      import(
        /* webpackChunkName: "addGiftCard" */
        './pages/Add-Gift-Card'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/Add-Gift-Card.tsx'),
          ).AddGiftCard
        : currentRouteName === 'addGiftCard'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({
                default: pageModule.AddGiftCard,
              })),
            );
    },
    path: '/:context?/myaccount/payments/addgiftcard',
    channel: null,
  },
  payments: {
    name: 'payments',
    componentName: 'Payments',
    chunk: () =>
      import(
        /* webpackChunkName: "payments" */
        './pages/Payments'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/Payments.tsx'),
          ).Payments
        : currentRouteName === 'payments'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({
                default: pageModule.Payments,
              })),
            );
    },
    path: '/:context?/myaccount/payments',
    channel: null,
  },
});
